// extracted by mini-css-extract-plugin
module.exports = {"logo":"index_logo__2oU88","link":"index_link__1B7j0","fixed_wrap":"index_fixed_wrap__1_MpH","close":"index_close__3DUZj"};